export const routes = {
  cards: {
    index: '/card-lists',
  },
  cardsAndLists: {
    index: '/cards-and-lists',
    activeTab: '/cards-and-lists/:activeTab',
  },
  map: {
    index: '/map',
  },
  videoWall: {
    index: '/video-wall',
  },
  app: {
    info: '/app/information',
    documentation: '/app/documentation',
    features: '/app/features',
  },
  auth: {
    reset: '/auth/reset/:token',
  },
  handlers: {
    all: '/handlers',
    create: '/handlers/create',
    other: '/handlers/create/other',
    read: '/handlers/:handlerId',
  },
  events: {
    eventDetails: '/events/:eventId',
    latest: '/events',
    archive: '/archive',
    archive2: '/archive2',
    statistic: {
      all: '/statistic',
      read: '/statistic/:diagramType',
      create: '/statistic/:create',
    },
  },
  sources: {
    main: '/sources',
    // Новая страница «Источники» (point3), GUI-3947
    list: '/sources',
    groupView: '/sources/groups/:groupId',
    streamView: '/sources/streams/:streamId',
    lunaStreams: {
      streams: {
        main: '/sources/luna-streams/streams',
        view: '/sources/luna-streams/streams/:streamId',
        create: '/sources/luna-streams/streams/create',
        edit: '/sources/luna-streams/streams/:streamId/edit',

      },
      groups: {
        main: '/groups',
        view: '/groups/:groupId',
        create: '/groups/create',
        edit: '/groups/:groupId/edit',
      },
      queue: {
        main: '/queue',
      },
    },
    vms: {
      main: '/vms',
    },
  },
  streams: {
    all: '/streams',
    read: '/streams/:streamId',
  },
  search: '/search',
  accounts: {
    all: '/accounts',
  },
  lists: {
    all: '/lists',
    read: '/lists/:listId',
  },
  tasks: {
    all: '/tasks',
  },
  notifications: {
    all: '/notifications',
    create: '/notifications/create',
    read: '/notifications/:notificationId',
  },
  externalId: {
    read: '/externalId/:externalId',
  },
  facePage: '/faces/:faceId',
  videoAnalytics: {
    all: '/video-analytics',
    streams: {
      edit: '/video-analytics/streams/:streamId/edit/',
    },
    archive: '/video-analytics/archive',
    details: '/video-analytics/:eventId',
  },
  permissionTags: {
    list: '/permission-tags',
    view: '/permission-tags/:permissionTag',
  },
  departments: {
    list: '/departments',
  },
  users: {
    list: '/users',
    view: '/users/:userId',
  },
  roles: {
    list: '/roles',
    view: '/roles/:roleId',
  },
  streamGroups: {
    view: '/stream-groups/:groupId',
  },
};
